module.exports = __webpack_public_path__ + "img/galette_2500px.6620bc4c.png";